import { defineStore } from 'pinia'
import { fetchUserBaseApi } from '@/features/user/api/userApi'
import { PLACEHOLDER_ASSETS } from '@/shared/assets/manifest'

export const useUserStore = defineStore('user', {
  state: () => ({
    user: {
      name: '默认用户',
      type: '普通会员',
      avatar: PLACEHOLDER_ASSETS.defaultAvatar,
    },
  }),
  actions: {
    setUser(user) {
      const next = { ...user }
      if (next.headUrl) {
        next.avatar = next.headUrl
      }
      this.user = { ...this.user, ...next }
    },
    setContinuousDays(days) {
      this.user.continuousDays = days
    },
    clearUser() {
      this.user = {
        name: '默认用户',
        type: '普通会员',
        avatar: PLACEHOLDER_ASSETS.defaultAvatar,
      }
    },
    async fetchUserInfo() {
      try {
        const response = await fetchUserBaseApi()
        if (response.data.code === 200 || response.data.code === 0) {
                    this.setUser(response.data.baseInfoVo)
        } else {
          console.error('获取用户信息失败:', response.data.errmsg)
        }
      } catch (error) {
        console.error('获取用户信息异常:', error)
      }
    },
  },
})
